import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const CarsPanel = ({ cars }) => {
  
  return (
    <Accordion
      sx={{
        mt: 2,
        mb: 2,
        '&::before': {
          display: 'none',
        },
      }}
      elevation={0}
      square
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">Cars</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          component="ul"
          sx={{
            m: 0,
            fontSize: 'body2.fontSize'
          }}
        >
          {cars.map(car => (
            <li key={car}>{car}</li>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default CarsPanel;
